const NS = 'SearchFilterSidebarWidget';
const CLS = 'searchFilterSidebarWidget';

export class SearchFilterSidebarWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$closeBtn = $(".searchFilterSidebarWidget-close");
		this.handleCloseBtn();
	}
	handleCloseBtn() {
		this.$closeBtn.on('click', () => {
			if($(".searchFilterSidebarWidget").hasClass("is-mbActive")){
				$( ".searchFilterSidebarWidget" ).removeClass( "is-mbActive" );
			}
		});
	}
}
